module.exports = __webpack_public_path__ + "static/images/41002eea.png";